import React, { Component } from "react";
import { saveAs } from "file-saver";
// import logo from './logo.svg';
// import './App.css';
import $ from "jquery";
import HomePage from "views/HomePage/HomePage";
import NaniTableTabs from "views/NaniTableTabs/NaniTableTabs";
import JSZip from "jszip";
import { func } from "prop-types";

class App extends Component {
  state = {
    dataType: {
      isMobile: false,
      isnaniApp: false,
      currentTab: "Home",
      isLogin: false,
      userToken: "",
      userID: "",
      userGetReportsData: {},
      selectTableTabID: 0,
      navigations: [true, false, false, false],
      reorganizationData: {},
      examinationPaperAnalysisID: "",
      examinationPaperAnalysisData: {},
      classResultID: "",
      classResult: {},
      answerAnalysisID: "",
      answerAnalysis: {}
    }
  };

  selectTab(tab) {
    //console.log("子物件呼叫到父物件");
    var dataType = this.state.dataType;
    dataType.currentTab = tab;

    this.setState({ dataType: dataType });
  }

  selectTableTab(tab) {
    var dataType = this.state.dataType;
    dataType.selectTableTabID = tab;

    this.setState({ dataType: dataType });
  }

  tableBtnToTabData(
    datanavigations,
    selectTableTabID,
    examinationPaperAnalysisID
  ) {
    var dataType = this.state.dataType;
    dataType.selectTableTabID = selectTableTabID;
    dataType.navigations = datanavigations;
    dataType.examinationPaperAnalysisID = examinationPaperAnalysisID;
    this.setState({ dataType: dataType });
  }

  tableBtnClassResult(datanavigations, selectTableTabID, classResultID) {
    var dataType = this.state.dataType;
    dataType.selectTableTabID = selectTableTabID;
    dataType.navigations = datanavigations;
    dataType.classResultID = classResultID;
    this.setState({ dataType: dataType });
  }

  tableBtnNaniAnswerAnalysis(
    datanavigations,
    selectTableTabID,
    classResultID,
    answerAnalysisID
  ) {
    var dataType = this.state.dataType;
    dataType.selectTableTabID = selectTableTabID;
    dataType.navigations = datanavigations;
    dataType.classResultID = classResultID;
    dataType.answerAnalysisID = answerAnalysisID;
    this.setState({ dataType: dataType });
  }

  // createData(student, answerRate, data) {
  //    counter += 1;

  //   var obj = { id: counter, student, answerRate };
  //   for (let index = 0; index < data.length; index++) {
  //     obj["ans" + (index + 1)] = data[index];
  //   }
  //   return obj;
  // }

  // getData(examlist, groupName) {
  //   var counter = 0;
  //   function createData(student, answerRate, data) {
  //     counter += 1;

  //     var obj = { id: counter, student, answerRate };
  //     for (let index = 0; index < data.length; index++) {
  //       obj["ans" + (index + 1)] = data[index];
  //     }
  //     return obj;
  //   }

  //   var testData = [];
  //   var getAnswer = 0;
  //   var getStudensAns = 0;
  //   var getAnswerRate = 0;

  //   if (examlist.students) {
  //     var ansTxt = examlist.correctAns;
  //     var ans = ansTxt.split(',');

  //     var students = {};
  //     Object.keys(examlist.students).map(function (objectKey, index) {
  //       var value = examlist.students[objectKey];
  //       var groupNameData = groupName.split('-');
  //       if (
  //         value.gradeNo.toString() == groupNameData[0] &&
  //         value.classNo.toString() == groupNameData[1]
  //       ) {
  //         students[objectKey] = value;
  //       }
  //     });
  //     //移除班級

  //     getAnswer = ans.length;
  //     //前三個為班級等資訊
  //     for (var getstudents in students) {
  //       getStudensAns = 0;
  //       var studentAnsTxt = students[getstudents].ans;
  //       // students[getstudents]
  //       var studentAns = studentAnsTxt.split(',');
  //       var ansData = [];
  //       //移除班級
  //       //for (let index = 3; index < ans.length; index++) {
  //       for (let index = 0; index < ans.length; index++) {
  //         const a = ans[index];
  //         const s = studentAns[index];
  //         if (a === s) {
  //           getStudensAns++;
  //         }
  //         // ansData.push
  //       }
  //       getAnswerRate = getStudensAns / getAnswer;
  //       getAnswerRate = (Math.round(getAnswerRate * 10000) / 100).toFixed(2) + '%';

  //       //改成顯示座號
  //       var studentNo = students[getstudents].no;
  //       testData.push(createData(studentNo, getAnswerRate, studentAns));
  //     }
  //   }

  //   return testData;
  // }

  // getRow(examlist) {
  //   var rowData = [];
  //   rowData.push({
  //     id: "student",
  //     numeric: false,
  //     disablePadding: true,
  //     label: "座號"
  //   });
  //   rowData.push({
  //     id: "answerRate",
  //     numeric: false,
  //     disablePadding: false,
  //     label: "答對率"
  //   });

  //   var ansTxt = examlist.correctAns;
  //   var ans = ansTxt.split(",");
  //   //移除班級
  //   for (let index = 0; index < ans.length; index++) {
  //     var title = index + 1;
  //     var dataIndex = "ans" + (index + 1);
  //     rowData.push({
  //       id: dataIndex,
  //       numeric: false,
  //       disablePadding: false,
  //       label: title
  //     });
  //   }
  //   return rowData;
  // }

  getRow(examlist) {
    var rowData = [];
    rowData.push("座號");
    rowData.push("答對率");

    var ansTxt = examlist.correctAns;
    var ans = ansTxt.split(",");
    //移除班級
    for (let index = 0; index < ans.length; index++) {
      var title = index + 1;

      //單獨下載是傳字串 所以這邊強制轉換成字串
      rowData.push(title.toString());
    }
    return rowData;
  }
  getData(examlist, groupName, dataRow) {
    // var counter = 0;
    function createData(student, answerRate, data, dataRow) {
      // counter += 1;

      // var obj = { id: counter, student, answerRate };
      // for (let index = 0; index < data.length; index++) {
      //   obj["ans" + (index + 1)] = data[index];
      // }
      var studentData = [];
      studentData.push(student);
      studentData.push(answerRate);
      var rowlength = dataRow.length - 2;
      for (let index = 0; index < rowlength; index++) {
        // obj["ans" + (index + 1)] = data[index];
        studentData.push(data[index]);
      }

      return studentData;
    }

    var testData = [];
    var getAnswer = 0;
    var getStudensAns = 0;
    var getAnswerRate = 0;

    if (examlist.students) {
      var ansTxt = examlist.correctAns;
      var ans = ansTxt.split(",");

      var students = {};
      Object.keys(examlist.students).map(function(objectKey, index) {
        var value = examlist.students[objectKey];
        var groupNameData = groupName.split("-");
        if (
          value.gradeNo.toString() == groupNameData[0] &&
          value.classNo.toString() == groupNameData[1]
        ) {
          students[objectKey] = value;
        }
      });
      //移除班級

      getAnswer = ans.length;
      //前三個為班級等資訊
      for (var getstudents in students) {
        getStudensAns = 0;
        var studentAnsTxt = students[getstudents].ans;
        // students[getstudents]
        var studentAns = studentAnsTxt.split(",");
        var ansData = [];
        //移除班級
        //for (let index = 3; index < ans.length; index++) {
        for (let index = 0; index < ans.length; index++) {
          const a = ans[index];
          const s = studentAns[index];
          if (a === s) {
            getStudensAns++;
          }
          // ansData.push
        }
        getAnswerRate = getStudensAns / getAnswer;
        getAnswerRate =
          (Math.round(getAnswerRate * 10000) / 100).toFixed(2) + "%";

        //改成顯示座號
        var studentNo = students[getstudents].no;
        var resetData = createData(
          studentNo,
          getAnswerRate,
          studentAns,
          dataRow
        );
        testData.push(resetData);
      }
    }

    testData.sort((a, b) => {
      var aNo = 0;
      var bNo = 0;
      try {
        aNo = parseInt(a[0]);
        bNo = parseInt(b[0]);
      } catch (error) {
        aNo = 0;
        bNo = 0;
      }
      if (aNo < bNo) {
        return -1;
      } else {
        return 1;
      }
    });

    return testData;
  }

  downloadTestPaperAllClass(classID) {
    var dataType = this.state.dataType;
    // eslint-disable-next-line no-console
    console.log(dataType);

    var testData;
    var students;
    dataType.userGetReportsData.forEach(element => {
      if (element.key == classID) {
        testData = element.value;
        students = element.value.students;
      }
    });

    var classData = [];
    var classObj = {};
    if (students) {
      Object.keys(students).map(function(objectKey, index) {
        var element = students[objectKey];
        var key = element.gradeNo + "-" + element.classNo;
        if (classData.indexOf(key) == -1) {
          classData.push(key);
          classObj[key] = { students: [] };
        }
        classObj[key]["students"].push(element);
      });

      Object.keys(classObj).map(function(objectKey, index) {
        var element = classObj[objectKey];
        element["correctAns"] = testData.correctAns;
        element["createTime"] = testData.createTime;
        element["decScores"] = testData.decScores;
        element["examName"] = testData.examName;
        element["examType"] = testData.examType;
        element["getScores"] = testData.getScores;
        element["year"] = testData.year;
      });

      console.log(classObj);

      var fileData = [];

      var zip = new JSZip();
      classData.forEach(classElement => {
        fileData = [];
        var dataRow = this.getRow(classObj[classElement]);
        fileData.push(dataRow);

        var studentAnswerData = this.getData(
          classObj[classElement],
          classElement,
          dataRow
        );
        studentAnswerData.forEach(element => {
          fileData.push(element);
        });
        console.log(fileData);
        // let rows = [["Id", "Name", "SortOrder"]];
        for (let i = 0; i < this.state.nums; i++) {
          fileData.push([`${i + 1}`, `NUM ${i + 1}`, `${i + 1}`]);
        }
        //utf8 加上bom
        let csvContent = "\uFEFF" + fileData.map(e => e.join(",")).join("\n");
        zip.file(classElement + ".csv", csvContent);
      });

      zip.generateAsync({ type: "blob" }).then(function(content) {
        // see FileSaver.js
        saveAs(content, testData.examName + ".zip");
      });
    } else {
      console.log("無學生資料");
    }
  }

  callTableData() {
    if (this.state.dataType.userToken) {
      var jwt = JSON.stringify({
        jwt: this.state.dataType.userToken
      });

      $.ajax({
        type: "POST",
        url:
          "https://us-central1-correctcheck-e286b.cloudfunctions.net/GetReports",

        data: JSON.stringify({
          token: jwt
        }),
        dataType: "json",
        contentType: "application/json",
        timeout: 30000,
        success: function(data, status, xhr) {
          if (data.status === "success") {
            //console.log(data.content.examList);
            var examlist = data.content.examList;
            console.log(" examlist ", examlist);
            var dataType = this.state.dataType;
            dataType.userGetReportsData = examlist;
            this.setState({ dataType: dataType });
          }
        }.bind(this),
        error: function(xhr, errorType, error) {
          console.log(xhr);
        }
      });
    }
  }

  changeLoginType(isLogin, userID, userToken) {
    var dataType = this.state.dataType;
    dataType.isLogin = isLogin;
    dataType.userID = userID;
    dataType.userToken = userToken;

    this.setState(
      { dataType: dataType },
      function() {
        this.callTableData();
      }.bind(this)
    );
  }

  naniEditData(data) {
    //nanilink的方法
  }

  naniLogout() {
    var dataType = this.state.dataType;
    dataType.currentTab = "Home";
    dataType.isLogin = false;
    dataType.userToken = {};
    dataType.userID = "";
    dataType.navigations = [];
    dataType.userGetReportsData = {};
    dataType.reorganizationData = {};
    dataType.examinationPaperAnalysis = {};
    dataType.classResult = {};
    dataType.answerAnalysis = {};
    this.setState({ dataType: dataType });
  }

  showTab(navigations) {
    this.setState({ navigations: navigations });
  }

  GetQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    return null;
  }

  // 20190121 資料將在這邊監聽
  componentDidMount() {
    var dataType = this.state.dataType;

    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      dataType.isMobile = true;
    }
    if (this.GetQueryString("naniapp")) {
      dataType.isnaniApp = true;
    }
    this.setState({ dataType: dataType });
    document.addEventListener(
      "callUserTokenDate",
      function(event) {
        var userToken = event.tokenData;
        var userID = event.userID;

        var jwt = "";
        if (userToken.jwt) {
          jwt = userToken.jwt;
        } else {
          jwt = userToken;
        }

        this.changeLoginType(true, userID, jwt);
      }.bind(this)
    );

    if (global.getNani_UserID() != "") {
      global.getLoginNaniCool(function myfunction(result) {
        var token = result;
        if (token) {
          let event = new Event("callUserTokenDate", { bubbles: true });
          event.tokenData = token;
          // event.userID = (JSON.parse(token)).username;
          event.userID = global.getNani_UserID();

          document.dispatchEvent(event);
        }
      });
    }
  }
  render() {
    var home = (
      <HomePage
        dataType={this.state.dataType}
        selectTab={this.selectTab.bind(this)}
        changeLoginType={this.changeLoginType.bind(this)}
        naniEditData={this.naniEditData.bind(this)}
        naniLogout={this.naniLogout.bind(this)}
        tableBtnToTabData={this.tableBtnToTabData.bind(this)}
        selectTableTab={this.selectTableTab.bind(this)}
        tableBtnClassResult={this.tableBtnClassResult.bind(this)}
        tableBtnNaniAnswerAnalysis={this.tableBtnNaniAnswerAnalysis.bind(this)}
        downloadTestPaperAllClass={this.downloadTestPaperAllClass.bind(this)}
      />
    );

    var table = (
      <NaniTableTabs
        dataType={this.state.dataType}
        selectTab={this.selectTab.bind(this)}
        changeLoginType={this.changeLoginType.bind(this)}
        naniEditData={this.naniEditData.bind(this)}
        naniLogout={this.naniLogout.bind(this)}
        tableBtnToTabData={this.tableBtnToTabData.bind(this)}
        selectTableTab={this.selectTableTab.bind(this)}
        tableBtnClassResult={this.tableBtnClassResult.bind(this)}
        tableBtnNaniAnswerAnalysis={this.tableBtnNaniAnswerAnalysis.bind(this)}
        downloadTestPaperAllClass={this.downloadTestPaperAllClass.bind(this)}
      />
    );

    return (
      <div>
        {this.state.dataType.isMobile && this.state.dataType.isnaniApp
          ? table
          : home}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js